import React from "react";
import { useNavigate } from "react-router-dom";
import i1 from "../Assets/aboutimg1.jpeg";

const AboutRight = () => {

  const navigate = useNavigate();

  return (
    <section className="w-full bg-[#f5f7fb] py-16 px-4 sm:px-6 lg:px-12 2xl:px-32">
      <div className="max-w-screen-2xl mx-auto">

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* LEFT IMAGE */}
          <div data-aos="fade-right">
            <img
              src={i1}
              alt="about"
              className="w-full h-[300px] sm:h-[400px] lg:h-[420px] object-cover rounded-2xl shadow-md"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div data-aos="fade-left">

            {/* Heading */}
            <h2 className="text-3xl sm: text-4xl font-bold text-gray-800 leading-tight">
              About GrowthLoom Digital – Digital Marketing &  <span className="text-yellow-500">Web Solutions Company</span>
            </h2>

            {/* Description */}
            <p className="text-gray-500 mt-4 text-sm sm:text-md leading-relaxed">
              GrowthLoom Digital is a results-driven digital marketing agency and web development company dedicated to helping businesses grow online. We specialize in delivering powerful digital marketing services, high-performance websites, and data-driven strategies that increase visibility, traffic, and conversions.
            </p>

            <p className="text-gray-500 mt-4 text-sm sm:text-md leading-relaxed">
              In today’s competitive digital landscape, having a strong online presence is essential. At GrowthLoom Digital, we combine creativity, technology, and analytics to help brands succeed across search engines, social media platforms, and digital channels.
            </p>

            {/* Points */}
            {/* <div className="mt-6 space-y-4">

              {[
                "10+ Years Industry Experience",
                "500+ Happy Clients",
                "Expert HR Consultants",
                "End-to-End Solutions",
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">

                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-blue-500 text-white text-sm">
                    ✓
                  </div>

                  <p className="text-gray-700 text-sm sm:text-base">
                    {item}
                  </p>
                </div>
              ))}

            </div> */}

            {/* Button */}
            <div className="mt-8">
              {/* <button
                onClick={() => navigate("/contact")}
                className="px-8 py-3 rounded-full text-white font-medium bg-gradient-to-r from-blue-500 to-blue-700 hover:opacity-90 transition"
              >
                Learn More
              </button> */}
              <button
                onClick={() => navigate("/contact")}
                className="px-8 py-3 rounded-full text-white font-medium bg-[#f99728] hover:opacity-90 transition"
              >
                Learn More
              </button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutRight;